<template>
  <div id="login-form">
    <Form
      :header="header"
      :model="model"
      :schema="schema"
      :options="options"
      :buttons="buttons"
      :messages="messages"
      @form_submit="form_submit"
      @button_click="button_click"
    ></Form>
  </div>
</template>

<script>
import Form from "../components/Form.vue";
import Vue from "vue";

export default {
  name: "CreateClient",
  components: {
    Form
  },
  data() {
    return {
      buttons: [
        {
          name: "return_button",
          style_classes: "mb-1 float-right",
          buttons: [
            {
              label: "Powrót",
              variant: "secondary",
              type: "button",
              name: "return_button",
              id: "return_button"
            },
            {
              label: "Utwórz",
              variant: "success",
              type: "submit",
              name: "create",
              id: "create_button",
              spinner: true,
              spinner_id: "create-spinner"
            }
          ]
        }
      ],
      header: {
        title: "Utwórz wniosek",
        icon: "person-plus-fill"
      },
      model: {
        pesel: null,
        given_name: null,
        family_name: null,
        phone_number: null
      },
      messages: [],
      options: {
        validateAfterChanged: true,
        validateAsync: true
      },
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "text",
                label: "PESEL",
                model: "pesel",
                required: true,
                validator: ["peselValidator"]
              },
              {
                styleClasses: "col-lg-5",
                type: "input",
                inputType: "text",
                label: "Imię",
                model: "given_name",
                required: true,
                autocomplete: true,
                validator: ["string"]
              },
              {
                styleClasses: "col-lg-7",
                type: "input",
                inputType: "text",
                label: "Nazwisko",
                model: "family_name",
                required: true,
                autocomplete: true,
                validator: ["string"]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "phone",
                label: "Telefon",
                model: "phone_number",
                placeholder: "np. +48123456789",
                required: true,
                autocomplete: true,
                validator: ["string"]
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    form_submit: function(model) {
      console.log(model);
      const spinner = document.getElementById("create-spinner");
      spinner.style.display = "block";
      Vue.Backend.create_client(
        model,
        this.$store.state.user.id_token,
        this.creation_success,
        this.creation_failure
      );
    },
    creation_success: function() {
      this.messages = [];
      this.$router.push({ name: "ProxyManage" });
    },
    creation_failure: function(err) {
      const spinner = document.getElementById("create-spinner");
      spinner.style.display = "None";
      console.log("Error:", err);
      this.messages = [];
      this.messages = [
        {
          label: err,
          variant: "danger"
        }
      ];
    },
    button_click: function(button_name) {
      if (button_name === "return_button") {
        this.$router.push({ name: "ProxyManage" });
      }
    }
  }
};
</script>

<style scoped></style>
